import React, { useCallback, useMemo } from 'react';
import { Col, Input, InputProps, Row } from 'tdesign-react';

import styles from './style/index.module.less';

const parseString = (val: string) => {
  const [oriEvent, last1] = val.replaceAll('，', '').replaceAll('。', '')
    .split('的时候');
  const [oriBehavior, last2] = (last1 || '').split('禁止');
  const [oriProhibit, oriExample] = (last2 || '').split('你可以采用如下话术');
  const event = oriEvent.replace('当', '');
  const behavior = oriBehavior.replace('你需要', '');
  return { event, behavior, prohibit: oriProhibit, example: oriExample || '' };
};

const getString = (val: {
  event: string;
  behavior: string;
  prohibit: string;
  example: string;
}) => {
  const { event, behavior, prohibit, example } = val;
  const res: string[] = [];
  if (!!event.trim()) {
    res.push(`当${event}的时候`);
  }
  if (!!behavior.trim()) {
    res.push(`你需要${behavior}`);
  }
  if (!!prohibit.trim()) {
    res.push(`禁止${prohibit}`);
  }
  if (!!example.trim()) {
    res.push(`你可以采用如下话术，${example}`);
  }
  return res.map((item, idx) => {
    if (idx < res.length - 1) {
      return `${item}，`;
    }
    return `${item}。`;
  }).join('');
};

export const InstructionInputComponent: React.FC<
{
  value: string;
  style?: React.CSSProperties
  onChange: (value: string) => void;
} & InputProps
> = (props) => {
  const compValue = useMemo(() => parseString(props.value || ''), [props.value]);

  const handleChange = useCallback((key: string, val: string) => {
    const newVal = { ...compValue, [key]: val };
    props.onChange(getString(newVal));
  }, [compValue, props.onChange]);

  return (
    <div style={{ ...props.style }}>
      <Row gutter={[16, 4]}>
        <Col className={styles.text} span={1}>当</Col>
        <Col span={10}>
          <Input
            value={compValue.event}
            onChange={(val) => {
              handleChange('event', val);
            }}
          />
        </Col>
        <Col className={styles.text} span={1}>的时候，</Col>
        <Col className={styles.text} span={1}>你需要</Col>
        <Col span={10}>
          <Input
            value={compValue.behavior}
            onChange={(val) => {
              handleChange('behavior', val);
            }}
          />
        </Col>
        <Col className={styles.text} span={1}>，</Col>
        <Col className={styles.text} span={1}>禁止</Col>
        <Col span={10}>
          <Input
            value={compValue.prohibit}
            onChange={(val) => {
              handleChange('prohibit', val);
            }}
          />
        </Col>
        <Col className={styles.text} span={1}>，</Col>
        <Col className={styles.text} span={2}>你可以采用如下话术，</Col>
        <Col span={9}>
          <Input
            value={compValue.example}
            onChange={(val) => {
              handleChange('example', val);
            }}
          />
        </Col>
        <Col className={styles.text} span={1}>。</Col>
      </Row>
    </div>
  );
};
